export const links = {
  connect: {
    root: '/',
  },
  signup: {
    root: '/signup',
    success: '/signup/success',
    verify: '/signup/verify',
  },
  login: {
    root: '/login',
    resetPassword: '/login/reset-password',
    forgotPassword: '/login/forgot-password',
  },
  dashboard: {
    root: '/dashboard',
    rewards: '/dashboard/rewards',
  },
}
